

import React, { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { post } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv, ImageWithLoader } from "@skeleton";
import ModalForGuest from "../ModalForGuest";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import axios from "../../API/axios";
import moment from "moment";
import { Tooltip } from "@mui/material";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { Link } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import ImageSliderModal from "../NewsFeed/ImageSliderModal";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";



const Medias = ({ uid, userData }) => {
  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  // const restrictedViewerTokenVideo = localStorage.getItem("restrictedViewerToken-video");
  const sessionId = localStorage.getItem("sessionId");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const [isError, setIsError] = useState(false);

  const [page, setPage] = useState(1);
  const [videoPage, setVideoPage] = useState(1);

  const [mediaList, setMediaList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [nextBatchLoading, setNextBatchLoading] = useState(false);

  const [hasMoreData, setHasMoreData] = useState(true);
  const [hasMoreVideos, setHasMoreVideos] = useState(true);

  const [totalPages, setTotalPages] = useState(1);
  const [videoTotalPages, setVideoTotalPages] = useState(1);

  const [activeTab, setActiveTab] = useState("Image");
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [Image, setImage] = useState("");
  const [singlePostId, setSinglePostId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [followModal, setFollowModal] = useState(false);
  const containerRef = useRef(null);
  const [postList, setPostList] = useState([]);

  const [dLike, setDLike] = useState(0);


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [isfollowed, setIsfollowed] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);

  const [imageList, setImageList] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [imageError, setImageError] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const pageSize = 8;
  const fetchMedia = async (mediaType, reset = false, pageNum = 1) => {
    try {
      // setNextBatchLoading(true);
      if (reset) setIsLoading(true);
      else setNextBatchLoading(true);
      const response = await axios.post(
        `Posts/GetUserPostsMediaList?MediaType=${mediaType}&UID=${uid}`,
        {
          deviceType: "Web",
          pageNumber: pageNum,
          pageSize: 8,
          langKey: language === "en" ? "" : language,
        }
      );

      const newMedia = response.data?.responseData?.postMediaList || [];
      const totalPages = response.data?.responseData?.paging?.totalPages || 1;
      setTotalPages(totalPages)

      if (mediaType === "Image") {
        setTotalPages(totalPages);
        if (newMedia.length > 0) {
          setImageList(reset ? newMedia : (prev) => [...prev, ...newMedia]);
          setImageError(false);
        } else if (pageNum === 1) {
          setImageList([]);
          setImageError(true);
        }
        setHasMoreData(pageNum < totalPages);
      }

      if (mediaType === "Video") {
        setVideoTotalPages(totalPages)
        if (newMedia.length > 0) {
          setVideoList(reset ? newMedia : (prev) => [...prev, ...newMedia]);
          setVideoError(false);
        } else if (pageNum === 1) {
          setVideoList([]);
          setVideoError(true);
        }
        setHasMoreVideos(pageNum < totalPages)
      }

      //   if (pageNum >= totalPages || newMedia.length < 8 ) {
      //     setHasMoreData(false);
      //   } else {
      //   setHasMoreData(true);
      // }

      // if (pageNum === 1) {
      //   setHasMoreData(true);
      // } else {
      //   if (pageNum >= totalPages || newMedia.length < 8) {
      //     setHasMoreData(false);
      //   } else {
      //     setHasMoreData(true);
      //   }
      // }

    } catch (error) {
      if (mediaType === "Image") {
        setImageError(true);
        setImageList([]);
        setHasMoreData(false);
      }
      if (mediaType === "Video") {
        setVideoError(true);
        setVideoList([]);
        setHasMoreVideos(false)
      }
    } finally {
      setIsLoading(false);
      setNextBatchLoading(false);
    }
  };

  // const fetchMedia = async (mediaType, reset = false) => {
  //   try {
  //     // setIsLoading(true);
  //     setNextBatchLoading(true);

  //     const response = await axios.post(
  //       `Posts/GetUserPostsMediaList?MediaType=${mediaType}&UID=${uid}`,
  //       {
  //         deviceType: "Web",
  //         pageNumber: page,
  //         pageSize: 9,
  //       }
  //     );

  //     const newMedia = response.data?.responseData?.postMediaList || [];
  //     const currentScroll = window.scrollY;
  //     if (newMedia.length > 0) {
  //         setMediaList((prev) => [...prev, ...newMedia]);
  //         setIsError(false); //  reset error
  //       } else {
  //         // Optional: if no newMedia, consider showing empty state
  //         setIsError(true);
  //         setMediaList([]);
  //       }

  //     // setMediaList((prev) => [...prev, ...newMedia]);
  //       setTimeout(() => {
  //           window.scrollTo({ top: currentScroll });
  //           }  , 50);
  //     setTotalPages(response.data.responseData.paging.totalPages);

  //     if (page >= response.data.responseData.paging.totalPages) {
  //       setHasMoreData(false);
  //     }
  //       setIsError(false);

  //   } catch (error) {
  //     if (error.response?.status === 404 || error.response?.status === 204) {
  //       setIsError(true);
  //       setMediaList([]);
  //     } else {
  //       console.error(error);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //     setNextBatchLoading(false);
  //   }
  // };

  useEffect(() => {
    // setMediaList([]);
    // setPage(1);
    // setHasMoreData(true);
    // setTotalPages(1)
    if (activeTab === "Image") {
      setPage(1);
      setHasMoreData(true);
      setImageList([]);
    } else {
      setVideoPage(1);
      setHasMoreVideos(true);
      setVideoList([]);
    }
    fetchMedia(activeTab, true, 1);
  }, [activeTab]);

  useEffect(() => {
    // if (page > 1 && hasMoreData) {
    //   fetchMedia(activeTab, false, page);
    // }
    const isImageTab = activeTab === "Image";
    const currentPage = isImageTab ? page : videoPage;
    const hasMore = isImageTab ? hasMoreData : hasMoreVideos;

    if (currentPage > 1 && hasMore) {
      fetchMedia(activeTab, false, currentPage);
    }
  }, [page, videoPage]);
  // -------------------------------------------------------------------------

  useEffect(() => {
    const handleScroll = () => {
      const isImageTab = activeTab === "Image";
      const hasMore = isImageTab ? hasMoreData : hasMoreVideos;

      if (
        hasMore && // Only proceed if more data exists for the active tab
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        if (isImageTab) {
          setPage((prev) => prev + 1);
        } else {
          setVideoPage((prev) => prev + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeTab, hasMoreData, hasMoreVideos]); // Depend on activeTab and tab-specific hasMoreData

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + document.documentElement.scrollTop + 1 >=
  //       document.documentElement.scrollHeight
  //     ) {
  //       setPage((prev) => prev + 1);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // useEffect(() => {
  //   document.body.style.overflow = showModal ? "hidden" : "unset";
  //   document.documentElement.style.overflow = showModal ? "hidden" : "";
  //   document.body.classList.toggle("modal-open", showModal);
  // }, [showModal]);

  const closeModalData = () => setFollowModal(false);
  const handleOpenProfileCloseModal = () => setOpenProfileModal(false);


  useEffect(() => {
    const timeout = setTimeout(() => {
      if (activeTab !== "Video" || !containerRef.current || !restrictedViewerTokens) return;

      const videoEls = containerRef.current.querySelectorAll("video");
      const plyrInstances = [];

      videoEls.forEach((videoEl) => {
        const videoId = videoEl.getAttribute("data-video-id");
        if (!videoId) return;

        const manifest = buildVideoIndexerManifestUrl({
          videoId,
          accessToken: restrictedViewerTokens,
        });

        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(manifest);
          hls.attachMedia(videoEl);

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            const plyr = new Plyr(videoEl, {
              captions: { active: true, update: true, language: "en" },
            });
            plyrInstances.push({ plyr, hls });
          });

          hls.on(Hls.Events.ERROR, (_, data) => {
            console.error("HLS.js Error:", data);
          });
        } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
          videoEl.src = manifest;
          const plyr = new Plyr(videoEl, {
            captions: { active: true, update: true, language: "en" },
          });
          plyrInstances.push({ plyr });
        }
      });

      return () => {
        plyrInstances.forEach(({ plyr, hls }) => {
          try {
            if (hls) {
              hls.destroy();
            }
          } catch (e) {
            console.warn("HLS cleanup failed", e);
          }
          if (plyr && typeof plyr.destroy === "function") {
            setTimeout(() => {
              try {
                plyr.destroy();
              } catch (e) {
                console.warn("Plyr cleanup failed", e);
              }
            }, 0);
          }
        });
      };
    }, 300);

    return () => clearTimeout(timeout);
  }, [videoList, activeTab, restrictedViewerTokens]);



  const handleTabChange = (type) => {
    // setMediaList([]); // force unmount video players
    // setPage(1);
    // setHasMoreData(true);
    setActiveTab(type);
  };

  //************************Delete Post start  ************************//
  const [showDeletePost, setShowDeletePost] = useState(false);

  const handleDeleteClose = () => {
    setShowDeletePost(false);
  };

  const deletePost = async () => {

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: singlePostId,
      langKey: language === "en" ? "" : language,
    };

    try {
      const res = await axios.post(`PostAction/DeletePost`, responseData);
      console.log('Delete response:', res);

      setToastMessage(res.data.message);
      setShowToast(true);

      flushSync(() => {
        handleDeleteClose();
      });

      setTimeout(() => {
        fetchMedia(activeTab);
      }, 0);

    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || "Something went wrong");
        setShowErrorToast(true);
      }
    }
  };


  //************************Delete Post End  ************************//

  const openModal = (mediaFiles, initialSlide) => {
    // setIsLoading(true);
    console.log("jjjjjjjjjjj");

    setIsModalOpen(true);


    // setSliderSettings((prevSettings) => ({
    //   ...prevSettings,
    //   initialSlide: initialSlide,
    // }));
    // setMediaFiles(mediaFiles);
    // setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postInfo.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              likeCount: post.postInfo.likeCount + delta,
            },
          }
          : post
      )
    );
  };
  return (
    <>
      {isLoading ? (
        <div className="mt-3">
          <ShimmerDiv height={250} width="100%" />
        </div>
      ) : isError && mediaList.length === 0 ? (
        <div className="mt-2 text-center">
          <img src={post.errorSmall} alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="aboutMe mb-3 p-3 MediaAllContent">

          <ul class="nav mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                // class="nav-link active"
                id="Photostab-tab"
                data-bs-toggle="pill"
                data-bs-target="#Photostab"
                type="button"
                role="tab"
                aria-controls="Photostab"
                aria-selected="true"
                class={`nav-link tab ${activeTab === "Image" ? "active" : ""}`}
                //  onClick={() => setActiveTab("Image")}
                onClick={() => handleTabChange("Image")}

              >
               {t("User Profile.Images")}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                // class="nav-link"
                id="Videotab-tab"
                data-bs-toggle="pill"
                data-bs-target="#Videotab"
                type="button"
                role="tab"
                aria-controls="Videotab"
                aria-selected="false"
                className={`nav-link tab ${activeTab === "Video" ? "active" : ""}`}
                onClick={() => setActiveTab("Video")}
              >
               {t("User Profile.Videos")}
              </button>
            </li>
          </ul>

          <div className="tab-content" ref={containerRef}>
            {activeTab === "Image" ? (
              imageError && imageList.length === 0 ? (
                <div className="text-center">
                  <img src={post.errorSmall} alt="No Images" width={200} />
                </div>
              ) : (
                <div className="row row-gap-3">
                  {imageList.map((item, index) => (
                    <div key={index} className="col-lg-6 col-md-6">
                      <div className="TabPhotoMaindiv border p-1">

                        <p className="f-14">
                          {moment.utc(item.creationTime).local().format("DD MMMM YYYY [at] h:mm a")}
                        </p>
                        <ImageWithLoader
                          src={item.mediaFile.mediaName}
                          alt={`img-${index}`}
                          className="img-fluid"
                          minHeight={220}
                          onClick={() => {
                            setOpenProfileModal(true);
                            setImage(item.mediaFile.mediaName);
                            setSinglePostId(item.postId);
                            setInitialSlideIndex(index);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )

            ) : (
              videoError && videoList.length === 0 ? (
                <div className="text-center">
                  <img src={post.errorSmall} alt="No Videos" width={200} />
                </div>
              ) : (
                <div className="row row-gap-3">
                  {videoList.map((item, index) => (
                    <div key={item.postId} className="col-lg-12 col-md-12">
                      <div className="TabPhotoMaindiv relative group video-overlay">

                        <video
                          key={`video-${index}-${item.mediaFile.mediaInfo}`}
                          id={`player-${index}`}
                          playsInline
                          controls
                          crossOrigin="true"
                          poster={item.mediaFile?.thumbnailName || ''}
                          data-video-id={item.mediaFile.mediaInfo}
                          className="w-100"
                        />

                        <div className="icon-overlay absolute top-0 right-0 m-2 hidden group-hover:flex space-x-2">

                          <Tooltip title={t("Manage Job.View")}>

                            <VisibilityIcon
                              className="v-icon"
                              onClick={() => {
                                openModal();
                                setOpenProfileModal(true);
                                setImage(item.mediaFile.mediaName);
                                setSinglePostId(item.postId);
                                setInitialSlideIndex(index);
                                setSinglePostId(item.postId);
                              }}
                            />
                          </Tooltip>
                          {userData?.profileInfo?.isOwn && (
                            <Tooltip title={t("Drafts.Delete")}>
                              <DeleteIcon
                                className="v-icon" onClick={() => {
                                  setShowDeletePost(!showDeletePost);
                                  setSinglePostId(item.postId);
                                }} />
                            </Tooltip>
                          )}
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              )
            )}
          </div>
        </div>
      )}

      {/* {!hasMoreData && <p className="text-center">No more data available</p>} */}
      {/* {
        !hasMoreData &&  (
          <p className="text-center">No more data available</p>
        )
      } */}
      {
        activeTab === "Image" ? (
          !hasMoreData && imageList.length > 8 &&(
            <p className="text-center">{t("Newsfeed.No more data available")}</p>
          )
        ) : (
          !hasMoreVideos && videoList.length > 8  &&(
            <p className="text-center">{t("Newsfeed.No more data available")}</p>
          )
        )
      }

      {nextBatchLoading && (
        (activeTab === "Image" && hasMoreData && imageList.length > 0) ||
        (activeTab === "Video" && hasMoreVideos && videoList.length > 0)
      ) && (
          <div className="text-center mb-4">
            <img src={post?.loader} width={50} alt="Loading..." />
          </div>
        )}

      {/* {nextBatchLoading && imageList.length > 0 && (
        <div className="text-center mb-4">
          <img src={post?.loader} width={50} alt="Loading..." />
        </div>
      )} */}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}



      {showDeletePost && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  {t("User Profile.Are You Sure You want to Delete?")}
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deletePost()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}


      {openProfileModal && (
        <ImageSliderModal
          singlepostId={singlePostId}
          isOpen={openProfileModal}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setSinglePostId={setSinglePostId}
          onRequestClose={handleOpenProfileCloseModal}
          ispostmodalOpen={ispostmodalOpen}
          setIspostmodalOpen={setIspostmodalOpen}
          initialSlideIndex={initialSlideIndex}
          setInitialSlideIndex={setInitialSlideIndex}
          restrictedViewerToken={restrictedViewerTokens}
          dLike={dLike}
          setDLike={setDLike}
          updateLikeCount={updateLikeCount}
          isfollowed={isfollowed}
          setIsfollowed={setIsfollowed}
          setPostList={setPostList}
        // images={modalImages}
        // item={singlePostContent} 
        // updateShareCount={updateShareCount}
        // totalPages={totalPages}
        // setTotalPages={setTotalPages}
        // page={page}
        // setPage={setPage}
        // // setPostList={postList}
        // AllPostList={AllPostList}
        // PostEngagement={PostEngagement}
        // updateCommentCount={updateCommentCount}
        // ispostmodalOpen={ispostmodalOpen}
        // setIspostmodalOpen={setIspostmodalOpen}
        // openModal={openModal}
        // setSinglePostContent={setSinglePostContent}
        // setShowModal={showModal}
        // handleLikesCloseModal={handleLikesCloseModal}
        // initialSlideIndex={initialSlideIndex}
        // setInitialSlideIndex={setInitialSlideIndex}
        // imageArray={imageArray}
        // restrictedViewerToken={restrictedViewerToken}

        />
      )}

      <SuccessToast show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
      <WarningToast show={showWarningToast} message={warningToastMessage} onClose={() => setShowWarningToast(false)} />
      <ErrorToast show={showErrorToast} message={ErrorToastMessage} onClose={() => setShowErrorToast(false)} />
    </>
  );
};

export default Medias;
